<template>
  <li
    class="litem"
    :class="{
      'litem--border': border,
      'litem--link': link,
    }"
  >
    <a
      v-if="link"
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
      class="litem__link"
    >
      <div>
        <slot name="presentation" />
      </div>
      <div>
        <slot name="content" />
      </div>
    </a>
    <template v-else>
      <div>
        <slot name="presentation" />
      </div>
      <div>
        <slot name="content" />
      </div>
    </template>
  </li>
</template>

<script setup lang="ts">
defineProps<{
  border?: boolean;
  link?: string;
}>();
</script>

<style lang="scss" scoped>
@use '@/styles/screens';

.litem:not(.litem--link),
.litem__link {
  display: grid;
  gap: 12px;

  @include screens.tablet {
    grid-template-columns: 140px 2fr;
  }

  @include screens.desktop {
    grid-template-columns: 200px 2fr;
  }
}

.litem:not(:last-child) {
  margin-bottom: 32px;
  padding-bottom: 32px;
}

.litem--border:not(:last-child) {
  border-bottom: 1px solid var(--color-border);
}
</style>
